import { api } from "./api";

export const vendorsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getVendors: builder.query({
      query: () => "api/Purch/Vendors",
      providesTags: ["vendors"],
    }),
    addVendor: builder.mutation({
      query: (formData) => ({
        url: "api/Purch/Vendors",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["vendors"],
    }),
    deleteVendor: builder.mutation({
      query: (sliderId) => ({
        url: `api/Purch/Vendors?VendorId=${sliderId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["vendors"],
    }),
    updateVendor: builder.mutation({
      query: (formData) => ({
        url: "api/Purch/Vendors",
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["vendors"],
    }),
  }),
});

export const {
  useGetVendorsQuery,
  useAddVendorMutation,
  useDeleteVendorMutation,
  useUpdateVendorMutation,
} = vendorsApi;
